"use client";

import { hideListToast } from "@/store/addToShoppingListSlice";
import { hideCartToast } from "@/store/shoppingCartSlice";
import { hidePublishedVendorReviewToast } from "@/store/vendorReviewToastSlice";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef, Suspense } from "react";
import { useDispatch } from "react-redux";

const ToastRouteCleanerInner = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const dispatch = useDispatch();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    dispatch(hideCartToast());
    dispatch(hideListToast());
    dispatch(hidePublishedVendorReviewToast());
  }, [pathname, searchParams, dispatch]);

  return null;
};

const ToastRouteClearer = () => (
  <Suspense>
    <ToastRouteCleanerInner />
  </Suspense>
);

export default ToastRouteClearer;
